import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, EditableDBItemV3, Grid, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { _keys, BadImplementationException } from '@nu-art/ts-common';
import { Component_TagEditor, ModuleFE_Tag } from '@app/hcs-frontend';
import './Manager_DiseaseView.scss';
import { ModuleFE_DiseaseView } from '../../_entity.js';
export class Manager_DiseaseView extends ComponentSync {
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        if (!state.view || nextProps.viewId !== state.view.item._id) {
            //@ts-ignore
            delete state.view;
            const view = ModuleFE_DiseaseView.cache.unique(nextProps.viewId);
            if (!view)
                throw new BadImplementationException(`Could not find view for id ${nextProps.viewId}`);
            state.view ??= new EditableDBItemV3(view, ModuleFE_DiseaseView);
        }
        return state;
    }
    // ######################### Logic #########################
    convertTagListToTagGroup = (tagList) => {
        const map = tagList.reduce((acc, tagId) => {
            const tag = ModuleFE_Tag.cache.unique(tagId);
            if (!tag)
                throw new BadImplementationException(`Could not find tag for id ${tagId}`);
            if (!acc[tag.tagIds[0]])
                acc[tag.tagIds[0]] = [];
            acc[tag.tagIds[0]].push(tag);
            return acc;
        }, {});
        return _keys(map).reduce((acc, key) => {
            const tag = ModuleFE_Tag.cache.unique(key);
            if (!tag)
                throw new BadImplementationException(`Could not find tag for id ${key}`);
            acc.push({ key: tag, value: map[key] });
            return acc;
        }, []);
    };
    // ######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { id: 'manager__disease-view', className: 'quai-item-manager', children: [this.renderHeader(), this.renderBody()] });
    }
    // ######################### Render - Header #########################
    renderHeader = () => {
        const view = this.state.view;
        return _jsx(LL_H_C, { className: 'manager__header', children: _jsxs(LL_V_L, { className: 'manager__header__main', children: [_jsx(LL_H_C, { className: 'manager__header__title', children: _jsx("span", { className: 'manager__header__title__label', children: view.item.label }) }), _jsxs(LL_H_C, { className: 'manager__header__sub-title', children: [_jsx("span", { className: 'manager__header__sub-title__item', children: "Disease View" }), "in", _jsx("span", { className: 'manager__header__sub-title__hierarchy', children: 'Disease Profiles > Views' })] })] }) });
    };
    // ######################### Render - Body #########################
    renderBody = () => {
        return _jsxs(LL_H_C, { className: 'manager__disease-view__body', children: [this.renderLeft(), _jsx("div", { className: 'data-separator' }), this.renderRight()] });
    };
    renderLeft = () => {
        const view = this.state.view;
        return _jsxs(Grid, { className: 'manager__data-grid', children: [_jsx("div", { className: 'data-grid__label', children: "Label" }), _jsx("div", { className: 'data-grid__data', children: view.item.label }), _jsx("div", { className: 'data-grid__label', children: "Type" }), _jsx("div", { className: 'data-grid__data', children: view.item.type }), _jsx("div", { className: 'data-grid__label', children: "Enforced Tags" }), _jsx("div", { className: 'data-grid__data', children: view.item.enforcedTags?.map(id => ModuleFE_Tag.cache.unique(id).label).join(', ') ?? 'N/A' })] });
    };
    renderRight = () => {
        const view = this.state.view;
        const whitelist = this.convertTagListToTagGroup(view.item.filter?.tagIds.whitelist ?? []);
        const blacklist = this.convertTagListToTagGroup(view.item.filter?.tagIds.blacklist ?? []);
        return _jsxs(Grid, { className: 'manager__data-grid', children: [_jsx("div", { className: 'data-grid__label full-span', children: "White List" }), _jsx(Component_TagEditor, { tags: whitelist, disableEdit: true, groupTagFilter: () => true, singleTagFilter: (tag, groupTag) => tag.tagIds[0] === groupTag._id }), _jsx("div", { className: 'data-grid__label full-span', children: "Black List" }), _jsx(Component_TagEditor, { tags: blacklist, disableEdit: true, groupTagFilter: () => true, singleTagFilter: (tag, groupTag) => tag.tagIds[0] === groupTag._id })] });
    };
}
//# sourceMappingURL=Manager_DiseaseView.js.map